import React from "react";
import { Clock, HeartHandshake, MapPinned, UserCheck, HeartPulse } from "lucide-react";
import { Reveal, MaskReveal } from "./Reveal";
import { WHY, IMAGES } from "../../lib/site";

const ICONS = [Clock, HeartHandshake, MapPinned, UserCheck, HeartPulse];

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5">
            <span className="flex items-center gap-3 text-[11px] tracking-[0.28em] uppercase text-[#D4AF37] font-semibold mb-5">
              <span className="h-px w-10 bg-[#D4AF37]" /> Why Choose KAT
            </span>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.03]">
              <MaskReveal lines={["The difference", "is personal."]} />
            </h2>
            <Reveal delay={0.2}>
              <p className="text-neutral-400 mt-6 leading-relaxed max-w-md">
                We're not a faceless rideshare platform. We're the ride your neighbors recommend — dependable, warm, and always on time.
              </p>
            </Reveal>
            <Reveal delay={0.3} className="mt-8 overflow-hidden rounded-2xl border border-white/10">
              <img src="https://images.unsplash.com/photo-1558222209-134191edfe0d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" alt="Chauffeur standing beside a black car" className="w-full h-56 object-cover opacity-80" />
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {WHY.map((w, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal
                  key={w.title}
                  delay={i * 0.09}
                  data-testid={`why-card-${i}`}
                  className={`group rounded-2xl border border-white/10 bg-[#111111] p-7 hover:border-[#D4AF37]/40 hover:-translate-y-1 transition-[border-color,transform] duration-400 ${
                    i === WHY.length - 1 ? "sm:col-span-2 border-[#D4AF37]/25 bg-[#141210]" : ""
                  }`}
                >
                  <div className="h-12 w-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-400">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-serif-display text-2xl text-white mt-5">{w.title}</h3>
                  <p className="text-neutral-400 mt-2 leading-relaxed text-sm">{w.desc}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
